module.exports = __webpack_public_path__ + "assets/images/3Tait9nbPH.png";


//////////////////
// WEBPACK FOOTER
// ../assets/images/index/01.png
// module id = 2172
// module chunks = 0